import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from "react-router-dom";
import Dashboard from './components/dashboard';
import Blog from './components/masters/Blog';
import Login from './components/Login';
import ProductImage from './components/masters/ProductImage'
import ImageData from './components/masters/ImageData'
import ProjectData from './components/masters/Project'
import TechPartner from './components/masters/TechPartner'
import Client from './components/masters/Client'
import Testimonial from './components/masters/Testimonial'
import Enquiry from './components/masters/Enquiry'
import JobPost from './components/masters/JobPost';
import JobEnquiry from './components/masters/JobEnquiry';
import OurProject from './components/masters/OurProject';
import BlogType from './components/masters/BlogType';
import Quote from './components/masters/Quote';
import WorkType from './components/masters/WorkType';
import PortFolioType from './components/masters/PortFolio';
import Collaborate from './components/Collaborate';
import ProductDetails from './components/ProductDetails';
import Themes from './components/masters/Theme';
import MobileSection from './components/MobileSection';
import Services from './components/Services';
import Creatives from './components/Creatives';
import ServiceDetails from './components/Common/ServiceDetails';
import ServiceDomains from './components/Common/ServiceDomains';
import Faqs from './components/Faqs';
import Overview from './components/Overview';
import JoinOurTeam from './components/JoinOurTeam';
import { BrowserRouter } from 'react-router-dom';

function App() {

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route exact path="/blog" element={<Blog />} />
          <Route exact path="/productimage" element={<ProductImage />} />
          <Route exact path="/imagedata" element={<ImageData />} />
          <Route exact path="/projectdata" element={<ProjectData />} />
          <Route exact path="/techpartner" element={<TechPartner />} />
          <Route exact path="/client" element={<Client />} />
          <Route exact path="/testimonial" element={<Testimonial />} />
          <Route exact path="/enquiry" element={<Enquiry />} />
          <Route exact path="/jobpost" element={<JobPost />} />
          <Route exact path="/jobenquiry" element={<JobEnquiry />} />
          <Route exact path="/ourproject" element={<OurProject />} />
          <Route exact path="/blogtype" element={<BlogType />} />
          <Route exact path="/quote" element={<Quote />} />
          <Route exact path="/work-type" element={<WorkType />} />
          <Route exact path="/portfolio-type" element={<PortFolioType />} />
          <Route exact path="/collaborate" element={<Collaborate />} />
          <Route exact path="/product-details/:id" element={<ProductDetails />} />
          <Route exact path="/theme" element={<Themes />} />
          <Route exact path="/mobile-section" element={<MobileSection />} />
          <Route exact path="/services" element={<Services />} />
          <Route exact path="/service-details/add" element={<ServiceDetails />} />
          <Route exact path="/service-details/:id/add" element={<ServiceDetails />} />
          <Route exact path="/service-details/:id/edit/:detailId" element={<ServiceDetails />} />
          <Route exact path="/service-details/:id" element={<ServiceDetails />} />
          <Route exact path="/service-details" element={<ServiceDetails />} />
          <Route exact path="/service-industries" element={<ServiceDomains/>} />
          <Route exact path="/service-industries/:id" element={<ServiceDomains />} />
          <Route exact path="/creatives" element={<Creatives />} />
          <Route exact path="/faqs" element={<Faqs />} />
          <Route exact path="/overview" element={<Overview />} />
          <Route exact path="/join-our-team" element={<JoinOurTeam />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
